export type FreeResource = {
  slug: string;
  title: string;
  description: string;
  downloadPath?: string;
};

// Add a real file to public/free-resources and set downloadPath before promoting a resource.
// Keeping this list explicit prevents a placeholder product file from being offered as a free download.
export const freeResources: FreeResource[] = [
  {
    slug: 'after-hours-starter-kit',
    title: 'Excel After Dark starter kit',
    description: 'A forthcoming collection of original Excel experiments, notes, and practical starting points.',
  },
];

export const findFreeResource = (slug: string) => freeResources.find((resource) => resource.slug === slug);
